<template>
  <div class="videoIng lw_video_bg">
    <div v-if="meeting_data&&meeting_data.video_img_path" class="header">
      <img width="100%" :src="meeting_data.video_img_path" alt="">
    </div>
    <div v-if="form&&form.id" class="videoIng_content">
      <div class="videoIng_content_title">{{form.title}}</div>
      <div class="videoIng_content_desc"><img width="12px" src="@/assets/auto_img/术者@2x.png" alt="">{{form.speaker}}</div>
      <play class="videoIng_content_doing" v-if="form.type==1" :form='form' :meeting_data='meeting_data' />
      <playMp4 class="videoIng_content_doing" v-if="form.type==2" :form='form' :meeting_data='meeting_data' />
      <!-- tab按钮 -->
      <div v-show='form.tab_data.is_enabled_tab==1' class="btnBox pointer">
        <div @click="changeListNum(index,item.type)" v-for="(item,index) in form.tab_data.tab_list" :key="index">
          {{item.title}}
          <span v-show="index==listNum" class="line"></span>
        </div>
      </div>

      <!-- tab详情，当配置图文tab时，第一个图文显示直播信息，其他隐藏 -->
      <div v-show='form.tab_data.is_enabled_tab==1&&listNum==index' v-for="(item,index) in  form.tab_data.tab_list"
        :key="index" class="showBox">
        <div v-show='item.type=="1"' class="p12 synopsis video_message">
          <viewer :images='[item.content]'>
            <div v-html="item.content" class="haibao"></div>
          </viewer>
        </div>
      </div>

      <!-- 无tab -->
      <div v-show='form.tab_data.is_enabled_tab==2' class="videoIng_content_hb" v-html="form.content"></div>

      <!-- 返回按钮 -->
      <back :baseData='meeting_data'></back>
    </div>
  </div>
</template>

<script>
import $ from 'jquery';
import { getWXConfig } from "@/api/login.js";
import { geiVideodetail } from '@/api/meetApi.js';
import backHome from '@/components/backHome.vue';
import playMp4 from "@/components/video/playMp4.vue";
import play from "@/components/video/play.vue";
import video_bill from "@/components/video/video_bill.vue";
import play_en from "@/components/video/play_en.vue";
import playMp4_en from "@/components/video/playMp4_en.vue";
import video_bill_en from "@/components/video/video_bill_en.vue";
import moment from 'moment';
import back from '../videoIng/back.vue';
export default {
  components: { back, playMp4, play, video_bill, playMp4_en, play_en, video_bill_en, backHome },
  name: "videoIng",
  data() {
    return {
      listNum: 0,
      isEn: false,
      form: {},
      meeting_data: {}
    };
  },
  mounted() { },
  created() {
    $("html,body").animate({
      scrollTop: 0
    }, 500);
    this.getVideoDetail()
  },
  methods: {
    moment,
    goVideo(id) {
      this.$router.push('/videoIng?id=' + id)
      this.getVideoDetail()
    },
    async getVideoDetail() {
      let data = await geiVideodetail({ id: this.$route.query.id, meeting_id: this.$route.query.meeting_id })
      this.form = data.payload.data
      console.log(this.form)
      this.meeting_data = data.payload.meeting_data
      document.title = this.form.title
      this.share()
      if (this.form.video_background_path) {
        console.log(document.querySelectorAll(".lw_video_bg"))
        document.querySelectorAll(".lw_video_bg")[0].style.background = 'url(' + this.form.video_background_path + ')';
      } else {
        document.querySelectorAll(".lw_video_bg")[0].style.backgroundColor = '#ffffff'
      }
      if (this.meeting_data.background_color) {
        document.querySelectorAll("body")[0].style.backgroundColor = this.meeting_data.background_color
        document.querySelectorAll("html")[0].style.backgroundColor = this.meeting_data.background_color
      }
    },
    changeListNum(index, type) {

      if (type == 'out_url') {
        // window.open(this.form.menuList[index].url,'_self ')
        window.location.href = this.form.menuList[index].url
        return
      } 

      this.listNum = index
    },
    async share() {
      // 
      // 
      // 注意，当直播是直接在素材库创建时可能没有meeting_data，所以这里要判断一下
      let data = null
      if (this.meeting_data && this.meeting_data.id) {
        data = await getWXConfig({ url: window.location.href, meeting_id: this.meeting_data.id })
      } else {
        data = await getWXConfig({ url: window.location.href })
        this.meeting_data.wechat_share_img_path = ''
        this.meeting_data.wechat_share_content = ''
        this.meeting_data.moments_share_img_path = ''
        this.meeting_data.moments_share_content = ''
      }

      let reg = /\\r\\n/ig

      this.WXConfig.wxShowMenu(
        data.payload,
        this.form.wechat_share_title ? this.form.wechat_share_title.replace(reg, "\r\n") : this.form.title,
        this.form.wechat_share_img_path ? this.form.wechat_share_img_path : this.meeting_data.wechat_share_img_path,
        this.form.wechat_share_content ? this.form.wechat_share_content.replace(reg, "\r\n") : this.meeting_data.wechat_share_content.replace(reg, "\r\n"),
        this.form.moments_share_title ? this.form.moments_share_title.replace(reg, "\r\n") : this.form.title,
        this.form.moments_share_img_path ? this.form.moments_share_img_path : this.meeting_data.moments_share_img_path,
        this.form.moments_share_content ? this.form.moments_share_content.replace(reg, "\r\n") : this.meeting_data.moments_share_content.replace(reg, "\r\n"),
      );

    }
  },
};
</script>

<style lang="less" scoped>
.videoIng_content {
  padding: 12px;
  margin: 12px;
  background-color: #fff;
  border-radius: 6px;
  overflow: hidden;
  .videoIng_content_title {
    font-family: PingFangSC, PingFang SC;
    font-weight: 600;
    font-size: 16px;
    color: #222222;
    font-style: normal;
    margin-bottom: 8px;
    text-align: center;
  }
  .videoIng_content_desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #8d8d8d;
    font-style: normal;
    margin-bottom: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      margin-right: 5px;
      position: relative;
      top: -1px;
    }
  }
  .videoIng_content_doing {
    border-radius: 6px;
    overflow: hidden;
  }
  .videoIng_content_hb {
    margin-top: 12px;
    border-radius: 6px;
    overflow: hidden;
  }
  .btnBox {
    margin-top: 12px;
    display: flex;
    line-height: 36px;
    border: 1px solid #ccc;
    div {
      flex: 1;
      text-align: center;
      position: relative;
    }
    .three {
      position: absolute;
      bottom: -5px;
      left: 50%;
      transform: translateX(-50%);
    }
  }
  .choice {
    color: #1890ff;
  }

  .line {
    position: absolute;
    width: 2em;
    left: 0;
    right: 0;
    margin: auto;
    height: 2px;
    background-color: #108ee9;
    bottom: 0;
    border-radius: 2px;
  }
}
.videoIng {
  background-repeat: no-repeat !important;
  background-size: 100% 100% !important;
  background-size: 100% 100%;
  min-height: 100vh;
  padding: 1px 0;
}
.noData {
  background-color: black;
  width: 100%;
  position: relative;
  height: 56.7vw;
  max-width: 768px;
  max-height: 436px;
  .noData_img {
    position: absolute;
    bottom: 0;
    color: #fff;
    padding: 8px;
    left: 0;
    font-size: 14px;
    line-height: 24px;
    text-align: center;
    width: 100%;
  }
}
::-webkit-scrollbar {
  width: 0px;
}
::scrollbar {
  width: 0px;
}
</style>
<style>
.baseFormBox_data .ant-cascader-picker,
.video_baseFormBox .ant-calendar-picker {
  width: 100%;
}
.videoIng_content_hb img {
  max-width: 100% !important;
  height: unset !important;
}
.showBox img {
  max-width: 100% !important;
  height: unset !important;
}
</style>